<template>
  <main>
    <form>
      <fieldset>
        <div class="clearfix" v-if="loading">
          <div class="loader"></div>
        </div>
        <!-- desktop -->
        <div class="clearfix flex flex-column justify-start items-start notosans darkblue" v-if="!showMobile && !loading">
          <div class="col-12 px0 mb3" v-if="selected.length > 0">
            <div class="flex">
              <p class="h5 semi-bold line-height-2 my2 darkblue">
                Mine opgavetyper
              </p>
              <div class="ml-auto p0 m0">
                <button @click="clearAlloption()" type="button" class="p1 px2 white-background border darkbue-border "><span class="p0 h6 darkblue regular">Ryd filter</span></button>
              </div>
            </div>
            <div class="dd my2 col-12 px0" id="nestable_list_1">
              <ol class="dd-list border primarycolor-border p1">
                <li class="dd-item inline-block pr1 rounded" :key="item.id" v-for="item in selected" :data-id="item">
                  <div class="p1 px2 darkblue-background white regular h6 line-height-3">{{ titleItem(item) }}</div>
                </li>
              </ol>
            </div>
          </div>
          <div class="col-12 pl0 pr1 mt2">
            <p class="h5 semi-bold line-height-2 darkblue">
              Vælg opgavetyper
            </p>
            <div class="col-12 p0" v-for="item in items" :key="item.industryId">
              <div>
                <!-- single checkbox item and collapse -->
                <div class="flex flex-column mb1 muted-background p1">
                  <div class="col-12 flex justify-between items-center">
                    <!-- checkbox and primary opgavetype and toggle chevron -->
                    <div>
                      <input style="height:18px;width:18px;" @change="updatewithguaranteemain(item)" type="checkbox" :id="'checkbox' + item.BRANCHE_ID" unchecked-value="not_accepted">
                      <!-- <span class="h5 semi-bold ml1 line-height-1 m0 p0" v-if="typeof item.USER_FRIENDLY_NAME !== 'null'">{{ item.USER_FRIENDLY_NAME}}</span> -->
                      <span class="h5 semi-bold ml1 line-height-1 m0 p0">{{item.BRANCHE}}</span>
                    </div>
                    <!-- toggle -->
                    <button type="button" class="transparent-button border-none not-rounded p1 line-height-1" v-b-toggle="'div' + item.BRANCHE_ID">
                      <span class="flex-none when-closed">
                        <span class="relative" style="top:3px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </span>
                      <span class="flex-none when-opened">
                        <span class="relative" style="top:3px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                        </span>
                      </span>
                    </button>
                  </div>
                  <div class="clearfix"></div>
                  <div class="clearfix pl2">
                    <b-collapse class="col-12 my3 m0 subItemCollapse" :id="'div' + item.BRANCHE_ID">
                      <!-- eslint-disable -->
                      <div class="flex flex-column justify-start items-center mb2" v-for="(subitem,index) in item.SubIndustries" :key="index"  v-if="subitem.PARENT_ID === 0"  >
                        <div class="col-12 border border-green border-left-0 border-top-0 border-right-0 ">
                          <input type="checkbox" style="width:16px;height:16px;" @change="updatewithguaranteeSub(item,subitem.SUBCATEGORY_ID)" :id="subitem.SUBCATEGORY_ID" v-model="selected" :value="subitem.SUBCATEGORY_ID" unchecked-value="not_accepted">
                          <span class="h5 darkblue regular inline-block ml1 mb0">{{ subitem.SUBCATEGORY_NAME }}</span>
                        </div>
                        <div class="col-11 mt1" v-for="(subitem_other,index) in item.SubIndustries" :key="index"  v-if="subitem_other.PARENT_ID === subitem.SUBCATEGORY_ID"  >
                          <div class="col-12 border border-green border-left-0 border-top-0 border-right-0 ">
                            <input type="checkbox" style="width:16px;height:16px;"  :id="subitem_other.SUBCATEGORY_ID" v-model="selected" :value="subitem_other.SUBCATEGORY_ID" unchecked-value="not_accepted">
                            <span class="h5 darkblue regular inline-block ml1 mb0">{{ subitem_other.SUBCATEGORY_NAME }}</span>
                          </div>
                        </div>
                        <!-- eslint-enable -->
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
            <div class="px2">
              <button type="button" v-if="showimentor" @click="opgave_action1()" class="h5 action-button gibson p2 px3 flex justify-center items-center not-rounded my3">
                <span class="semi-bold">Gem opgavetyper</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
        </div>
        <!-- mobile -->
        <div class="clearfix" v-if="showMobile && !loading">
          <div class="col-12 px0">
            <p class="h5 semi-bold line-height-2 my2 darkblue">
              Vælg opgavetyper
            </p>
            <div class="col-12 px0" v-for="item in items" :key="item.industryId">
              <div>
                <!-- single checkbox item and collapse -->
                <div id="mobilecheckbox" class="flex flex-column mb1 muted-background p1 py2">
                  <div class="flex justify-start items-center">
                    <!-- checkbox and primary opgavetype and toggle chevron -->
                    <div>
                      <input style="height:18px;width:18px;" @change="updatewithguaranteemain(item)" type="checkbox" :id="'checkbox' + item.BRANCHE_ID" unchecked-value="not_accepted">
                      <!-- <span class="h5 semi-bold ml1 line-height-1 m0 p0" v-if="typeof item.USER_FRIENDLY_NAME !== 'null'">{{ item.USER_FRIENDLY_NAME}}</span> -->
                      <span class="h5 semi-bold ml1 line-height-1 m0 p0">{{item.BRANCHE}}</span>
                    </div>
                    <!-- toggle -->
                    <button type="button" class="transparent-button border-none not-rounded p1 line-height-1" v-b-toggle="'div' + item.BRANCHE_ID">
                      <span class="flex-none when-closed">
                        <span class="relative" style="top:3px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </span>
                      <span class="flex-none when-opened">
                        <span class="relative" style="top:3px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="18" height="18" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                        </span>
                      </span>
                    </button>
                  </div>
                  <div class="clearfix"></div>
                  <div class="clearfix pl2">
                    <b-collapse class="col-12 my2 m0 subItemCollapse" :id="'div' + item.BRANCHE_ID">
                      <!-- eslint-disable -->
                      <div class=" mb2" v-for="(subitem,index) in item.SubIndustries" :key="index"  v-if="subitem.PARENT_ID === 0"  >
                        <div class="border border-green border-left-0 border-top-0 border-right-0 ">
                          <input type="checkbox" style="width:16px;height:16px;" @change="updatewithguaranteeSub(item,subitem.SUBCATEGORY_ID)" :id="subitem.SUBCATEGORY_ID" v-model="selected" :value="subitem.SUBCATEGORY_ID" unchecked-value="not_accepted">
                          <span class=" darkblue regular inline-block ml1 mb0">{{ subitem.SUBCATEGORY_NAME }}</span>
                        </div>
                        <div class="col-11 mt1" v-for="(subitem_other,index) in item.SubIndustries" :key="index"  v-if="subitem_other.PARENT_ID === subitem.SUBCATEGORY_ID"  >
                          <div class="border border-green border-left-0 border-top-0 border-right-0 ">
                            <input type="checkbox" style="width:16px;height:16px;"  :id="subitem_other.SUBCATEGORY_ID" v-model="selected" :value="subitem_other.SUBCATEGORY_ID" unchecked-value="not_accepted">
                            <span class=" darkblue regular inline-block ml1 mb0">{{ subitem_other.SUBCATEGORY_NAME }}</span>
                          </div>
                        </div>
                      </div>
                        <!-- eslint-enable -->
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
            <div class="px2">
              <button type="button" :disabled="parsingcheckbox" v-if="showimentor" @click="opgave_action1()" class="xs-col-12 sm-col-12 md-col-8 lg-col-6 h5 action-button gibson p2 flex justify-center items-center not-rounded my3">
                <span class="semi-bold">Gem opgavetyper</span>
                <span class="mx2"><i class="el-icon-right"></i></span>
              </button>
            </div>
          </div>
          <div class="col-12 px0">
            <p class="h5 semi-bold line-height-2 my2 darkblue">
              Valgte opgavetyper
            </p>
            <div class="dd my2" id="nestable_list_1">
              <ol class="dd-list">
                <!-- eslint-disable -->
                <li class="dd-item inline-block pr1" v-for="item in selected" :data-id="item" >
                  <div class="p1 px2 muted-background darkblue regular h6 line-height-3">{{ titleItem(item) }}</div>
                </li>
                <!-- eslint-enable -->
              </ol>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
    <b-modal  centered hide-footer hide-header id="confirmGarantee" :no-close-on-backdrop="true" size="md" v-model="confirmGarantee" ref="confirmGarantee" no-close-on-esc>
      <div class="col-12 flex justify-end items-center white-background ">
            <button type="button" @click="closeconfirmGarantee()" class="white-button no-border not-rounded gibson ">
              <span>
              <i class="el-icon-close"></i>
              </span>
            </button>
          </div>
      <div class="clearfix white-background px2 ">
        <div class="flex flex-column col-12 p0">
          <p class="my2 darkblue mx-auto">
          <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 24 24" fill="none" stroke="#19A3C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-octagon"><polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </p>
          <p class="bold h3 darkblue pt1 mx-auto" >Tak for besøget</p>
            <p class="h6 darkblue py1 mt2 mx-auto" >Du ændrer din jobdefinition. Du mister din garanti fra os. Er du sikker på, at du vil fortsætte ?</p>
        </div>
      </div>
      <div class="flex justify-around my2">
      <button type="button" class="center p2 px3 outlined-button" @click="closeconfirmGarantee()"><span class="h6 regular">Afbestille</span></button>
      <button type="button" class="center p2 px3 action-button" @click="toggleAllSubIndustry(seletecteditem['item'], seletecteditem['sub'])" v-if="seletecteditem['type'] === 'sub'"><span class="h6 regular">Blive ved</span></button>
      <button type="button" class="center p2 px3 action-button" @click="toggleAllIndustry(seletecteditem['item'])" v-else-if="seletecteditem['type'] === 'main'"><span class="h6 regular">Blive ved</span></button>
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="false" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'dineopgavetyper',
  props: [
    'enterpriseid',
    'ispartnerGuarantee'
  ],
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
    this.gettaskbitrix()
    // this.Reload()
  },
  components: {
    loading,
    Simplert
  },
  data () {
    return {
      items: [],
      showimentor: true,
      show: false,
      label: 'Loading...',
      overlay: 1,
      selected: [],
      selectedinitial: [],
      loading: true,
      selectedtasktype: [],
      selectedtasktypeeach: [],
      parsingcheckbox: false,
      salesPersonbitrix: '',
      confirmGarantee: false,
      seletecteditem: {}
    }
  },
  methods: {
    toggleAlarmpris (checked) {
      this.form.alarmpris.selected = checked ? this.form.alarmpris.choices.slice() : []
    },
    clearAlloption () {
      this.selected = []
      this.items.forEach(l => {
        document.getElementById('checkbox' + l.BRANCHE_ID).checked = false
        document.getElementById('div' + l.BRANCHE_ID).style.display = 'none'
      })
    },
    showpopupConfirmgarantee (item, SUBCATEGORY_ID, type) {
      if (type === 'sub') {
        this.seletecteditem['item'] = item
        this.seletecteditem['sub'] = SUBCATEGORY_ID
        this.seletecteditem['type'] = type
      } else if (type === 'main') {
        this.seletecteditem['item'] = item
        this.seletecteditem['type'] = type
      }
      setTimeout(() => {
        this.confirmGarantee = true
      }, 200)
    },
    closeconfirmGarantee () {
      this.loading = true
      this.gettaskbitrix()
      this.confirmGarantee = false
    },
    opgave_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      if (this.selected.length === 0) {
        this.modalShowDato = false
        // this.loading = false
        let obj = {
          title: 'Gennemført!',
          message: '',
          type: 'danger'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      var dataPartner = {operation: 'producttask', salesPerson: this.salesPerson, category: this.selected}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            // this.loading = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              // this.loading = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    opgave_action1 () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      if (this.selected.length === 0) {
        this.modalShowDato = false
        // this.loading = false
        let obj = {
          title: 'Vælg Opgavetyper!',
          message: '',
          type: 'danger'
        }
        this.$refs.simplert.openSimplert(obj)
        return
      }
      var thisvar = this
      let confirmFn = function () {
        thisvar.saveselectedtaskbitrix()
      }
      let obj = {
        // title: 'Bekræfts',
        customClass: 'confirmDialog',
        message: 'Jeg bekræfter hermed, at jeg og/eller mine medarbejdere er uddannet til at udføre de valgte opgavetyper.',
        useConfirmBtn: true,
        customIconUrl: 'static/svg/warning-blue.svg',
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'action-button h5 regular p2 px3 mb2',
        customCloseBtnClass: 'standard-button h5 regular p2 px3 mb2',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    opgave_action2 () {
      this.show = true
      var serialize = []
      this.selected.forEach((a, index) => {
        var individ = {}
        individ['id'] = a
        serialize.push(individ)
      })
      // $('#nestable_list_1').nestable('serialize')
      var dataPartner = {
        operation: 'newproducttask',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        category: this.selected,
        sort: JSON.stringify(serialize)
      }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            // this.loading = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              // this.loading = false
              // let obj = {
              //   title: '',
              //   customClass: 'confirmDialog',
              //   customIconUrl: 'static/svg/blue-checkmark.svg',
              //   message: '<div class="col-12 flex flex-column"><div><p class="h2 regular darkblue line-height-3">Gennemført!</p></div><div></div></div>',
              //   type: 'success',
              //   customCloseBtnText: 'Luk',
              //   customCloseBtnClass: 'button border-none not-rounded h5 regular p2 px3'
              // }
              // this.$refs.simplert.openSimplert(obj)
            } else {
              // alert(res.message)
            }
          },
          response => {
            // alert('error')
          }
        )
    },
    titleItem (item) {
      for (var Subitem in this.items) {
        for (var Subitem1 in this.items[Subitem].SubIndustries) {
          if (this.items[Subitem].SubIndustries[Subitem1].SUBCATEGORY_ID === parseInt(item)) {
            return this.items[Subitem].SubIndustries[Subitem1].SUBCATEGORY_NAME
          }
        }
      }
    },
    toggletasksub (taskitem, mainId, subId, subName) {
      if (document.getElementById('checkboxtasktype' + taskitem.taskTypeId).checked) {
        var tasktypedetails = {}
        tasktypedetails['taskTypeId'] = taskitem.taskTypeId
        tasktypedetails['taskTypeName'] = taskitem.name
        tasktypedetails['subcategoryId'] = subId
        tasktypedetails['subcategoryName'] = subName
        tasktypedetails['mainIndustryId'] = mainId
        this.selectedtasktype.push(tasktypedetails)
      } else {
        this.removetasktypefromsub(this.selectedtasktype, taskitem.taskTypeId)
      }
    },
    toggleAllsub (suitem, mainTaskId = '') {
      if (document.getElementById(suitem.SUBCATEGORY_ID).checked) {
        document.getElementById('checkbox' + mainTaskId).checked = true
        var thisvarmp = this
        if (suitem.taskTypes) {
          if (suitem.taskTypes.length > 0) {
            suitem.taskTypes.forEach(a => {
              var tasktypedetails = {}
              tasktypedetails['taskTypeId'] = a.taskTypeId
              tasktypedetails['taskTypeName'] = a.name
              tasktypedetails['subcategoryId'] = suitem.SUBCATEGORY_ID
              tasktypedetails['subcategoryName'] = suitem.SUBCATEGORY_NAME
              tasktypedetails['mainIndustryId'] = mainTaskId
              document.getElementById('tasktype' + a.taskTypeId).classList.remove('hide')
              document.getElementById('checkboxtasktype' + a.taskTypeId).checked = true
              thisvarmp.selectedtasktype.push(tasktypedetails)
            })
          } else {
            var taskdetailed2 = {}
            taskdetailed2['taskTypeId'] = ''
            taskdetailed2['taskTypeName'] = ''
            taskdetailed2['subcategoryId'] = suitem.SUBCATEGORY_ID
            taskdetailed2['subcategoryName'] = suitem.SUBCATEGORY_NAME
            taskdetailed2['mainIndustryId'] = mainTaskId
            thisvarmp.selectedtasktype.push(taskdetailed2)
          }
        } else {
          var taskdetails3 = {}
          taskdetails3['taskTypeId'] = ''
          taskdetails3['taskTypeName'] = ''
          taskdetails3['subcategoryId'] = suitem.SUBCATEGORY_ID
          taskdetails3['subcategoryName'] = suitem.SUBCATEGORY_NAME
          taskdetails3['mainIndustryId'] = mainTaskId
          thisvarmp.selectedtasktype.push(taskdetails3)
        }
        //   document.getElementById('tasktype' + a.taskTypeId).classList.remove('hide')
        //   document.getElementById('checkboxtasktype' + a.taskTypeId).checked = true
        //   this.selectedtasktype.push(tasktypedetails)
        // })
      } else {
        var varthis = this
        if (suitem.taskTypes) {
          if (suitem.taskTypes.length > 0) {
            var unchosen = []
            varthis.selectedtasktype.forEach((c) => {
              unchosen.push(c.taskTypeId)
            })
            suitem.taskTypes.forEach(a => {
              document.getElementById('tasktype' + a.taskTypeId).classList.add('hide')
              document.getElementById('checkboxtasktype' + a.taskTypeId).checked = false
              if (unchosen.includes(a.taskTypeId)) {
                this.removeallItemtasktosub(varthis.selectedtasktype, suitem.SUBCATEGORY_ID)
              }
            })
          } else {
            this.removeallItemtasktosub(this.selectedtasktype, suitem.SUBCATEGORY_ID)
          }
        } else {
          this.removeallItemtasktosub(this.selectedtasktype, suitem.SUBCATEGORY_ID)
        }
        var unchosenfiltered = []
        unchosenfiltered = this.selectedtasktype.filter((a) => {
          return a.mainIndustryId === mainTaskId
        })
        if (unchosenfiltered.length === 0) {
          document.getElementById('checkbox' + mainTaskId).checked = false
        }
      }
    },
    toggleAllIndustry (item) {
      if ($('#checkbox' + item.IndustryId).is(':checked')) {
        $('#div' + item.IndustryId).show()
        for (var Subitem in item.SubIndustries) {
          this.selected.push(item.SubIndustries[Subitem].SUBCATEGORY_ID)
        }
      } else {
        for (var Subitem1 in item.SubIndustries) {
          this.removeItem(this.selected, item.SubIndustries[Subitem1].SUBCATEGORY_ID)
        }
      }
      this.confirmGarantee = false
    },
    toggleAllSubIndustry (item, SUBCATEGORY_ID) {
      if ($('#' + SUBCATEGORY_ID).is(':checked')) {
        for (var Subitem in item.SubIndustries) {
          if (item.SubIndustries[Subitem].PARENT_ID.toString() === SUBCATEGORY_ID.toString()) {
            this.selected.push(item.SubIndustries[Subitem].SUBCATEGORY_ID)
          }
        }
      } else {
        for (var SubitemDel in item.SubIndustries) {
          if (item.SubIndustries[SubitemDel].PARENT_ID.toString() === SUBCATEGORY_ID.toString()) {
            this.removeItem(this.selected, item.SubIndustries[SubitemDel].SUBCATEGORY_ID)
          }
        }
      }
      this.confirmGarantee = false
    },
    updatewithguaranteeSub (item, SUBCATEGORY_ID) {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee(item, SUBCATEGORY_ID, 'sub')
      } else {
        this.toggleAllSubIndustry(item, SUBCATEGORY_ID)
      }
    },
    updatewithguaranteemain (item) {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee(item, '', 'main')
      } else {
        this.toggleAllIndustry(item)
      }
    },
    toggleAll (item) {
      if ($('#checkbox' + item).is(':checked')) {
        $('#' + item).show()
        for (var Subitem in this.items) {
          if (this.items[Subitem].parent_id === item) {
            this.selected.push(this.items[Subitem].id)
          }
        }
      } else {
        $('#' + item).hide()
        for (var Subitem1 in this.items) {
          if (this.items[Subitem1].parent_id === item) {
            this.removeItem(this.selected, this.items[Subitem1].id)
          }
        }
      }
    },
    removeallItemtasktosub (arr, suitemid) {
      arr.splice(arr.findIndex(a => a.SUBCATEGORY_ID === suitemid), 1)
    },
    removetasktypefromsub (arr, taskTypeId) {
      arr.splice(arr.findIndex(b => b.taskTypeId === taskTypeId), 1)
    },
    removeItem (array, item) {
      for (var i in array) {
        if (array[i] === item) {
          array.splice(i, 1)
          break
        }
      }
    },
    firstSelected () {
      // for (var Subitem in this.items) {
      //   for (var Subitem1 in this.items[Subitem].subcategories) {
      //     if (this.selected.indexOf(this.items[Subitem].subcategories[Subitem1].subcategoryId) !== -1) {
      //       document.getElementById('checkbox' + this.items[Subitem].industryId).checked = true
      //       $('#div' + this.items[Subitem].industryId).show()
      //     }
      //   }
      // }
      var thisvar = this
      this.items.forEach(a => {
        var mainid = a.BRANCHE_ID
        a.SubIndustries.forEach(b => {
          var subid = b.SUBCATEGORY_ID
          if (thisvar.selected.includes(b.SUBCATEGORY_ID)) {
            $('#div' + mainid).show()
            document.getElementById('checkbox' + mainid).checked = true
            document.getElementById(subid).checked = true
            if (b.taskTypes) {
              b.taskTypes.forEach(z => {
                if (thisvar.selectedinitial.includes(z.taskTypeId)) {
                  var tasktypedetails = {}
                  tasktypedetails['taskTypeId'] = z.taskTypeId
                  tasktypedetails['taskTypeName'] = z.name
                  tasktypedetails['subcategoryId'] = b.SUBCATEGORY_ID
                  tasktypedetails['subcategoryName'] = b.SUBCATEGORY_NAME
                  tasktypedetails['mainIndustryId'] = a.BRANCHE_ID
                  document.getElementById('tasktype' + z.taskTypeId).classList.remove('hide')
                  document.getElementById('checkboxtasktype' + z.taskTypeId).checked = true
                  var hasid = []
                  hasid = this.selectedtasktype.filter(a => {
                    return a.taskTypeId === z.taskTypeId
                  })
                  if (hasid.length < 1) {
                    this.selectedtasktype.push(tasktypedetails)
                  }
                }
              })
            }
          }
        })
      })
    },
    gettaskbitrix () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      this.haaId = localStorage.getItem('haaid')
      // https://bitrixapi.haandvaerker.dk/v1/task/getTaskTypes
      this.$http.get(this.$bitrixapi + 'industries/full/' + this.haaId, {headers}, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.items = res.data
            this.getselectedtaskbitrix()
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    getselectedtaskbitrix () {
      this.haaId = localStorage.getItem('haaid')
      // https://bitrixapi.haandvaerker.dk/v1/
      this.$http.get(this.$bitrixapi + 'supplier/GetSupplierProfileById/' + this.haaId, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.loading = false
            this.selected = res.data.c_partner_task_profile
            if (typeof this.selected !== 'undefined') {
              setTimeout(() => this.firstSelected(), 300)
            } else {
              this.loading = false
            }
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        })
      }, 3500)
    },
    saveselectedtaskbitrix () {
      // https://bitrixapi.haandvaerker.dk/v1/
      this.show = true
      if (this.enterpriseid === 0) {
        this.$emit('noenterprise', true)
        return false
      }
      this.loading = true
      var serialize = []
      this.selected.forEach((a, index) => {
        var individ = {}
        individ['id'] = a
        serialize.push(individ)
      })
      var data = {
        partnerId: this.haaId,
        category: this.selected,
        taskTypes: JSON.stringify(this.selectedtasktype),
        sort: JSON.stringify(serialize)
      }
      this.$http.post(this.$bitrixapi + 'task/savePartnerTaskProfile', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          this.show = false
          if (res.success) {
            this.getselectedtaskbitrix()
            this.modalShowDato = false
            this.loading = false
            this.show = false
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          } else {
            alert('Error')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        })
      }, 3500)
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.loading = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.lavproduct
            if (res.newdataObjselect instanceof Array) {
              this.selected = res.newdataObjselect
            }
            setTimeout(() => this.firstSelected(), 500)
          },
          response => {
            alert('error')
          }
        )
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        })
      }, 3500)
    },
    toggleElektrikerpris (checked) {
      this.form.elektrikerpris.selected = checked ? this.form.elektrikerpris.choices.slice() : []
    },
    toggleGaragepris (checked) {
      this.form.garagepris.selected = checked ? this.form.garagepris.choices.slice() : []
    },
    toggleGulvpris (checked) {
      this.form.gulvpris.selected = checked ? this.form.gulvpris.choices.slice() : []
    },
    // onSubmit (evt) {
    //   evt.preventDefault()
    //   alert(JSON.stringify(this.form))
    // },
    onReset (evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.alarmprisTypes = ''
      // this.form.name = ''
      // this.form.food = null
      // this.form.checked = []
    }
  },
  watch: {
    alarmSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.alarmpris.indeterminate = true
        this.form.alarmpris.allSelected = false
      } else if (newVal.length === this.form.alarmpris.choices.length) {
        this.form.alarmpris.indeterminate = false
        this.form.alarmpris.allSelected = true
      } else {
        this.form.alarmpris.indeterminate = false
        this.form.alarmpris.allSelected = false
      }
    },
    elektrikerSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.elektrikerpris.indeterminate = true
        this.form.elektrikerpris.allSelected = false
      } else if (newVal.length === this.form.elektrikerpris.choices.length) {
        this.form.elektrikerpris.indeterminate = false
        this.form.elektrikerpris.allSelected = true
      } else {
        this.form.elektrikerpris.indeterminate = false
        this.form.elektrikerpris.allSelected = false
      }
    },
    garageSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.garagepris.indeterminate = true
        this.form.garagepris.allSelected = false
      } else if (newVal.length === this.form.garagepris.choices.length) {
        this.form.garagepris.indeterminate = false
        this.form.garagepris.allSelected = true
      } else {
        this.form.garagepris.indeterminate = false
        this.form.garagepris.allSelected = false
      }
    },
    gulvSelected (newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.gulvpris.indeterminate = true
        this.form.gulvpris.allSelected = false
      } else if (newVal.length === this.form.gulvpris.choices.length) {
        this.form.gulvpris.indeterminate = false
        this.form.gulvpris.allSelected = true
      } else {
        this.form.gulvpris.indeterminate = false
        this.form.gulvpris.allSelected = false
      }
    }
  }
}
</script>
<style lang="less">
fieldset[role="group"] {
  margin-bottom: 8px;
}
#mobilecheckbox .custom-control-input {
    position: inherit;
    z-index: 1;
    opacity: 1;
}
#mobilecheckbox .custom-control {
  padding-left: 0;
  margin-right: 8px;
}
.border-mildgray {
  border: 1px solid #003645;
  border-radius: 5px;
}
.dd-empty {
  border: 0px dashed #bbb;
  min-height: 0px;
  background-color: #e5e5e5;
  background-size: 60px 60px;
  background-position: 0 0, 30px 30px;
}
.col-form-legend {
  font-weight: 700;
  font-size: 0.875rem;
}
.custom-checkbox {
  margin-bottom: 0;
  margin-right:0;
  .custom-control-indicator {
    background: #95a5a6;
  }
}
.custom-control-input:disabled ~ .custom-control-description {
  font-weight: 400!important;
}
.fa-save {
  font-size: 26px;
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// DineOpgavetyper.vue?2beb2186